module.exports = __webpack_public_path__ + "img/win-icon5.10907fb.png";